import { useSelectedClient } from '@entities/clients/heplers.ts';
import type React from 'react';
import { Link } from 'react-router-dom';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import { Blank } from 'library/components/common';
import { useLoadConsultations } from '../../model';
import { Card } from '../card';
import * as st from './styles.module.scss';

type Props = {
  id: number;
};

export const ConsultationList: React.FC<Props> = ({ id }) => {
  const { loadMore, consultations, loading, hasNextPage } = useLoadConsultations(id);
  const { selectedClient } = useSelectedClient();
  return (
    <>
      <InfinityList className={st.list} loading={loading} hasMore={hasNextPage} loadMore={loadMore}>
        {consultations.map((consultation) => (
          <Link key={consultation.id} to={`${selectedClient?.id}/consultation/${consultation.id}`}>
            <Card id={consultation.id} />
          </Link>
        ))}
        {consultations.length === 0 && !loading && (
          <Blank text="У Вас нет ни одной запланированной консультации" />
        )}
      </InfinityList>
    </>
  );
};
